import {
  defaultLanguage,
  supportPhone,
  supportEmail,
} from 'src/utils/capabilities';
import { EmailLink } from 'src/components/common/EmailLink';
import { PhoneHelper } from 'src/utils/phoneHelper';
import {
  FORBIDDEN_PAGE_URL,
  UNAUTHORIZED_PAGE_URL,
  DEPRECATED_FEATURE_PAGE,
} from 'src/constants/urlConstants';

const PhoneLink = phone => PhoneHelper.getPhoneLink(phone);

const defaultErrorCopies = {
  en: {
    'defaultError.title': 'Oops! an unexpected error occurred',
    'defaultError.altImgText': 'Call us',
    'defaultError.subtitle1_text1': 'Please call us at',
    'defaultError.subtitle1_text2': ' to continue the',
    'defaultError.subtitle1_text3':
      'process with one of our insurance advisors',
    'defaultError.subtitle2_text1': 'Or click',
    'defaultError.subtitle2_text2': 'here',
    'defaultError.subtitle2_text3': 'to go to the homepage',
  },
  'es-AR': {
    'defaultError.title': '',
    'defaultError.altImgText': 'Llámanos',
    'defaultError.subtitle1_text1': 'Por favor llámenos a',
    'defaultError.subtitle1_text2': ' Para continuar con',
    'defaultError.subtitle1_text3': 'el proceso',
    'defaultError.subtitle2_text1': 'O haga click',
    'defaultError.subtitle2_text2': 'aquí',
    'defaultError.subtitle2_text3': 'Para ir a la pagina de inicio',
  },
};

const defaultErrorKeys = t => ({
  title: t('notFoundPage.pageTitle'),
  subtitle1_text1: t('notFoundPage.reachAt'),
  subtitle1_text2: t('notFoundPage.or'),
  subtitle1_text3: t('notFoundPage.viaEmail'),
  subtitle2_text1: null,
  subtitle2_text2: t('notFoundPage.clickHere'),
  subtitle2_text3: t('notFoundPage.backHome'),
});

export const translateErrorKey = key => {
  const keys = defaultErrorCopies[defaultLanguage] || defaultErrorCopies.en;
  return keys[key];
};

const errorKeys = (t, errorKey) => {
  const errorOptions = {
    defaultError: {
      title: translateErrorKey('defaultError.title'),
      subtitle1_text1: translateErrorKey('defaultError.subtitle1_text1'),
      subtitle1_text2: translateErrorKey('defaultError.subtitle1_text2'),
      subtitle1_text3: translateErrorKey('defaultError.subtitle1_text3'),
      subtitle2_text1: translateErrorKey('defaultError.subtitle2_text1'),
      subtitle2_text2: translateErrorKey('defaultError.subtitle2_text2'),
      subtitle2_text3: translateErrorKey('defaultError.subtitle2_text3'),
    },
    unauthorized: {
      ...defaultErrorKeys(t),
      title: t('unauthorizedErrorPage.title'),
      subtitle: t('unauthorizedErrorPage.subtitle'),
    },
    forbidden: {
      title: t('forbiddenErrorPage.title'),
      subtitle: supportPhone && supportEmail && (
        <>
          {t('forbiddenErrorPage.subtitle_text1')}{' '}
          <EmailLink email={supportEmail} />{' '}
          {t('forbiddenErrorPage.subtitle_text2')}{' '}
          <PhoneLink phone={supportPhone} />
        </>
      ),
    },
    deprecated: {
      title: t('deprecated.title'),
      subtitle: t('deprecated.subtitle'),
      haveAnAccount: t('haveAnAccount'),
      loginHere: t('loginHere'),
    },
  };

  return errorOptions[errorKey];
};

export const errorTexts = ({ t, error, pathname }) => {
  const is401 = pathname === UNAUTHORIZED_PAGE_URL;
  const isForbidden = pathname === FORBIDDEN_PAGE_URL;
  const is410 = pathname === DEPRECATED_FEATURE_PAGE;

  return (
    errorKeys(t, [
      error ||
        (is401 && 'unauthorized') ||
        (isForbidden && 'forbidden') ||
        (is410 && 'deprecated'),
    ]) || defaultErrorKeys(t)
  );
};
